import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function ModalDialog({ children, modalDialogClassName }) {
  useEffect(() => {
    $('body').css('overflow', 'hidden');

    return () => {
      $('body').css('overflow', 'auto');
    };
  }, []);

  return (
    <div className="component-modal-dialog">
      <div className={`modal-dialog ${modalDialogClassName}`}>
        {children}
      </div>
    </div>
  );
}

ModalDialog.defaultProps = {
  children: null,
  modalDialogClassName: '',
};

ModalDialog.propTypes = {
  children: PropTypes.array,
  modalDialogClassName: PropTypes.string,
};

export default ModalDialog;
